import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SidebarItemModel } from '../../shared/models/sidebar-item.model';


const sidebar = [
  {
    description: 'users',
    icon: 'assets/img/icon-users.svg',
    url: '/home/users'
  },
  {
    description: 'certificates',
    icon: 'assets/img/icon-certificate.svg',
    url: '/home/certificates'
  },
  {
    description: 'arm-certificates',
    icon: 'assets/img/icon-certificate.svg',
    url: '/home/certificates/arm'
  }
];

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  constructor() { }

  find(): Observable<SidebarItemModel[]> {
    return of(sidebar);
  }

}
